<template>
  <div :class="classnames" ref="productFiltersWrap">
    <div :class="`${ns}__inner`" ref="productFilters">
      <CollectionSearch
        v-if="!isOnProductDetailPage"
        :collections="collections" :items="collectionsMenuItems"
        :activeCollection="activeCollection"/>
      <DateRangeFilter
        :dateRange="dateRangeFilterRange"
        :selectedDateRange="dateRangeFilterSelectedRange"
        @datePickerDateChange="dateRangeFilterChangeHandler"
      />

      <ProductFilterVariants
        v-if="isOnProductDetailPage"
        :possibleFilters="possibleFilters"
        :totalFiltersActive="totalFiltersActiveOptions"
        isOnProductDetailPage
      />

      <div v-if="!isOnProductDetailPage" class="filter-buttons" :class="{active: isFiltersVisible}">
        <div class="filter-button-wrap filter-button-wrap--filters">
          <VueButton v-if="!isFiltersVisible"  appearance="fat-light" direction="rtl" @click="handleFiltersToggle">
            <template v-if="!isOnProductDetailPage" slot="text"><span class="button-text--filter">Filters</span></template>
            <template slot="icon">
              <img class="icon-funnel" src="../../assets/images/icon-funnel.png" />
            </template>
          </VueButton>
          <VueButton v-else appearance="fat-dark" direction="rtl" @click="handleFiltersToggle">
            <template v-if="!isOnProductDetailPage" slot="text"><span class="button-text--filter">Filters</span></template>
            <template slot="icon">
              <img class="icon-funnel" src="../../assets/images/icon-funnel.png" />
            </template>
          </VueButton>
        </div>

        <div v-if="!isOnProductDetailPage" class="filter-button-wrap  filter-button-wrap--dashboard">
          <VueButton v-if="!isDashboardVisible" appearance="fat-light" direction="rtl" @click="handleDashboardToggle">
            <template v-if="!isOnProductDetailPage" slot="text"><span class="button-text--stats">Stats</span></template>
            <template slot="icon">
              <span style="font-size: 18px; ">%</span>
            </template>
          </VueButton>
          <VueButton v-else appearance="fat-dark" direction="rtl" @click="handleDashboardToggle">
            <template v-if="!isOnProductDetailPage" slot="text"><span class="button-text--stats">Stats</span></template>
            <template slot="icon">
              <span style="font-size: 18px; ">%</span>
            </template>
          </VueButton>
        </div>
        <div v-if="!isOnProductDetailPage" class="filter-button-wrap filter-button-wrap--reset">
          <button class="filter-reset" @click="handleResetButtonClick">Reset</button>
        </div>
      </div>

      <div class="sticky-share-buttons">
        <ToolbarSearchButton />
        <ToolbarShareButton :shareData="shareButtonData" />
        <ToolbarMoreMenu :lists="moreMenuItems" />
      </div>

    </div>
    <div class="tags-types-options" ref="filtersBar" v-if="isFiltersVisible">
      <ProductFilterTags
        :isOnProductDetailPage="isOnProductDetailPage"
        :totalFiltersActive="totalFiltersActiveTags"
      />
      <ProductFilterOptions
        :isOnProductDetailPage="isOnProductDetailPage"
        :totalFiltersActive="totalFiltersActiveOptions"
      />
      <ProductFilterProductTypes
        :isOnProductDetailPage="isOnProductDetailPage"
        :totalFiltersActive="totalFiltersActiveProductTypes"
      />
      <ProductFilterVendors
        v-if="hasMultipleVendors"
        :isOnProductDetailPage="isOnProductDetailPage"
        :totalFiltersActive="totalFiltersActiveVendors"
      />
      <img
        class="filter-close"
        src="../../assets/images/icon-close.png"
        @click="handleFiltersToggle"
      />
    </div>
  </div>
</template>

<script>
  // import ScrollMagic from 'scrollmagic'
  import { mapState } from 'vuex'

  import CollectionSearch from '@/components/CollectionSearch'
  import DateRangeFilter from '@/components/DateRangeFilter'
  import ProductFilterOptions from '@/components/ProductFilterOptions'
  import ProductFilterProductTypes from '@/components/ProductFilterProductTypes'
  import ProductFilterTags from '@/components/ProductFilterTags'
  import ProductFilterVendors from '@/components/ProductFilterVendors'
  import ProductFilterVariants from '@/components/ProductFilterVariants'
  import ToolbarEditMenu from '@/components/ToolbarEditMenu'
  import ToolbarMoreMenu from '@/components/ToolbarMoreMenu'
  import ToolbarSearchButton from '@/components/ToolbarSearchButton'
  import ToolbarShareButton from '@/components/ToolbarShareButton'
  import VueButton from '@/components/VueButton'
  import ScrollMagic from 'ScrollMagic'

  import { bem } from '@/mixins/bem.js'

  const namespace = 'product-filters'

  export default {
    name: 'product-filters',
    components: {
      CollectionSearch,
      DateRangeFilter,
      ProductFilterOptions,
      ProductFilterProductTypes,
      ProductFilterTags,
      ProductFilterVariants,
      ProductFilterVendors,
      ToolbarEditMenu,
      ToolbarMoreMenu,
      ToolbarSearchButton,
      ToolbarShareButton,
      VueButton
    },
    mixins: [ bem ],
    props: {
      activeCollection: String,
      collections: Array,
      collectionsMenuItems: Array,
      dateRangeFilterChangeHandler: Function,
      dateRangeFilterRange: Object,
      dateRangeFilterSelectedRange: String,
      filtersActive: Array,
      isDashboardVisible: Boolean,
      isFiltersVisible: Boolean,
      isOnProductDetailPage: Boolean,
      possibleFilters: Array,
      scrollToggle: Function,
      shareButtonData: Object,
      shareData: Object
    },
    data: function () {
      return {
        editMenuItems: [
          {
            text: 'Images',
            url: '#'
          },
          {
            text: 'Title',
            url: '#'
          },
          {
            text: 'Price',
            url: '#'
          },
          {
            text: 'Sale Price',
            url: '#'
          },
          {
            text: 'Variants',
            url: '#'
          },
          {
            text: 'Collections',
            url: '#'
          },
          {
            text: 'Description',
            url: '#'
          }
        ],
        moreMenuItems: [
          [
            {
              text: 'Share Collection',
              share: this.shareData
            },
            {
              text: 'Edit Collection in Shopify',
              url: 'javascript:void(0);' // need from backend
            },
            {
              text: 'View Live Collection',
              url: 'javascript:void(0);' // need from backend
            }
          ],
          [
            {
              text: 'Settings',
              url: '/settings'
            },
            {
              text: 'Help',
              url: '/help'
            }
          ]
        ]
      }
    },
    computed: {
      ...mapState(
        'shop',
        [
          'hasMultipleVendors'
        ]
      ),
      totalFiltersActiveOptions: function () {
        return this.getTotalAcitveFilters('option')
      },
      totalFiltersActiveProductTypes: function () {
        return this.getTotalAcitveFilters('product')
      },
      totalFiltersActiveTags: function () {
        return this.getTotalAcitveFilters('tag')
      },
      totalFiltersActiveVendors: function () {
        return this.getTotalAcitveFilters('vendor')
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    mounted: function () {
      const controller = new ScrollMagic.Controller()
      new ScrollMagic.Scene({
        triggerElement: '.page-toolbar',
        triggerHook: 0,
        offset: '60%'
      }).setClassToggle(this.$refs.productFiltersWrap, 'sticky--DISABLE')
      .addTo(controller)
    },
    methods: {
      classnameModifiers: function () {
        const whichPage = this.isOnProductDetailPage ? 'pdp' : 'plp'

        return [
          whichPage
        ]
      },
      handleDashboardToggle: function () {
        this.$emit('toggleDashboard')
      },
      handleFiltersToggle: function () {
        this.$emit('toggleFilters')
      },
      handleResetButtonClick: function () {
        const href = window.location.href.toLowerCase()
        const onCollection = href.indexOf('collection') !== -1

        if (onCollection) {
          // good, when NOT on "All Products"
          this.$router.push('/')
        } else {
          // good, when on "All Products"
          this.$router.go()
        }
      },
      handleScrollToggle: function (isVisible) {
        this.$emit('scrollToggle', isVisible)
      },
      getTotalAcitveFilters: function (type) {
        const filtersActiveByType = this.filtersActive.filter((filter) => {
          return filter.filter_type.toLowerCase().indexOf(type) !== -1
        })

        const total = filtersActiveByType.length

        return total
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../scss/abstracts/__dir';
  @import '../../scss/global/__dir';

  .product-filters {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
    @include breakpoint($desktop) {

    }
    .button-wrap {
      height: 52px !important;
    }
  }

  .product-filters--pdp {
    padding-top: 0;
    margin-top: 15px !important;
    @include breakpoint($tablet) {
      margin-top: 25px !important;
    }
    @include breakpoint($desktop-large) {
      margin-top: 15px !important;
    }
  }

  .tags-types-options {
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 25px;
    padding: 30px;
    background: #EFEFEF;
    margin-top: 15px;
    border-radius: 4px;

    @media screen and (min-width: 1024px) {
      padding: 35px 40px 35px;
      grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
    }

    @media screen and (min-width: 1440px) {
      z-index: -1;
    }

    &.hide {
      visibility: hidden;
      pointer-events: none;
      opacity: 0;
    }

    .sticky & {
      width: 100%;
      left: 0px;
      top: 64px;
      border-radius: 0px;
      position: fixed;
    }
  }

  .button-text--filter,
  .button-text--stats {
    display: inline-block;
  }

  .button-text--filter {
    padding-right: 6px;
  }

  .button-text--stats {
    padding-right: 8px;
  }

  .filter-close {
    transform: scale(0.5);
    -webkit-backface-visibility: hidden;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 5;
    cursor: pointer;
    opacity: 0.8;
    &:hover {
      opacity: 1;
    }
  }

  .icon-funnel {
    transform: scale(0.5);
  }

  .filter-button-wrap {
    margin-right: 15px;
    display: flex;
    align-items: center;
  }

  .filter-buttons {
    width: 100%;
    display: flex;
    transition: opacity 300ms ease;

    .sticky & {
      .filter-button-wrap--dashboard {
        opacity: 0;
        display: none;
      }
    }

    @include ipad-portrait {
      //margin-top: 15px !important;
    }

    @include breakpoint($tablet-landscape) {
      margin-top: 0;
    }
  }

  .sticky-share-buttons {
    display: flex;
    align-items: center;
    width: 100%;
    opacity: 0;
    pointer-events: none;
    display: none;
    .interactive-svg-icon:hover, .interactive-svg-icon--is-active {
      color: #fff !important;
    }
    .interactive-svg-icon:hover {
      color: #fff !important;
    }
    .sticky & {
      @media screen and (min-width: 1200px) {
        display: flex;
        opacity: 1;
        pointer-events: auto;
        transition: opacity 300ms ease;
        opacity: 1;
        justify-content: flex-end;
      }
    }

  }
  .filter-reset {

    font-size: 14px;
    color: #999999;
    letter-spacing: 0;
    text-decoration: underline;

    &:hover {
      color: #000;
      .sticky & {
        color: #fff;
      }
    }

  }
  .sticky-share-buttons {
    .interactive-svg-icon:hover, .interactive-svg-icon--is-active {
      color: #fff !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/js/components/ProductFilters.vue